"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardCarousel = exports.getVisibleTabCount = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("..");
const navigation_bar_1 = require("./navigation-bar");
const styled_1 = require("./styled");
const components_core_1 = require("@volkswagen-onehub/components-core");
const typing_1 = require("../text-custom/typing");
const slider_card_carousel_1 = require("./slider-card-carousel");
/**
 * Change visible tab on mobile and desktop view
 * @param tabBarWidth number
 * @param totalTabs  number
 */
const getVisibleTabCount = (sliderWidth, visibleCards, tabletVisibleCards, hidePeekaboo, desktopBreakpoint, tabletBreakpoint) => {
    if (sliderWidth === 0) {
        return visibleCards;
    }
    const isDesktopViewport = window.matchMedia(`(min-width: ${desktopBreakpoint || __1.Breakpoints.b960}px)`).matches;
    const isTabletViewport = window.matchMedia(`(min-width: ${tabletBreakpoint || __1.Breakpoints.b560}px)`).matches;
    if (isDesktopViewport) {
        return visibleCards;
    }
    else if (isTabletViewport) {
        return tabletVisibleCards || visibleCards;
    }
    return hidePeekaboo ? 1 : 2;
};
exports.getVisibleTabCount = getVisibleTabCount;
const CardCarousel = (props) => {
    const { children, visibleCards, visibleCardOnTablet, hidePeekaboo, pageOffset, showElementNumber, desktopBreakpoint, tabletBreakpoint, onActionTrackingTrigger } = props;
    // Carousel index it can be for page or card index
    const [activeIndex, setActiveIndex] = react_1.default.useState(0);
    const totalElements = children.length;
    const [sliderWidth, sliderElementRef] = (0, __1.useElementWidth)();
    // const viewport = useViewportType(Breakpoints.b960, Breakpoints.b560);
    const visibleTabCount = (0, exports.getVisibleTabCount)(sliderWidth, visibleCards, visibleCardOnTablet, hidePeekaboo, desktopBreakpoint, tabletBreakpoint);
    /** Flags  */
    const isMobileView = visibleTabCount <= 2;
    const isNotMinTotalElements = totalElements <= visibleTabCount;
    const isSingleElement = isMobileView && totalElements < 2;
    const blockNavigation = (isMobileView && totalElements < 2) ||
        (!isMobileView && totalElements < visibleTabCount);
    /**
     * Helpers
     */
    const getMaxTotalElements = () => isMobileView
        ? totalElements
        : pageOffset
            ? Math.ceil(totalElements / (visibleTabCount - 1))
            : totalElements + 1;
    const isElementOpacity = (index) => (pageOffset && !isMobileView
        ? activeIndex * (visibleTabCount - 1)
        : activeIndex) +
        (isMobileView ? 1 : visibleTabCount - 1) ===
        index;
    /**
     * Get page number element
     * Create text element with number format
     */
    const getPageNumberString = () => {
        if (!showElementNumber)
            return undefined;
        const elementIndex = pageOffset
            ? activeIndex * (prevVisibleTabCount - 1)
            : activeIndex;
        const elementBound = elementIndex + (visibleTabCount - 1);
        const nextElement = elementBound >= totalElements
            ? elementIndex + (totalElements % elementIndex)
            : elementBound;
        return (react_1.default.createElement(__1.TextCustom, { appearance: components_core_1.TokenTextAppearance.headline200, style: {
                fontSize: typing_1.TextSize.TextSize16,
                lineHeight: typing_1.TextLineHeight.TextLineHeight20
            } },
            react_1.default.createElement(__1.TextCustom, { style: { fontWeight: typing_1.TextWeight.bold } }, isMobileView
                ? `${elementIndex + 1}`
                : `${elementIndex + 1}-${nextElement}`),
            ` of ${totalElements}`));
    };
    const maxTotalElements = getMaxTotalElements();
    const relativeVisibleCards = visibleTabCount + 1;
    const slider = (0, __1.useSlider)({
        offset: activeIndex,
        visibleSlideCount: visibleTabCount,
        sliderWidth: sliderWidth,
        totalSlideCount: isNotMinTotalElements
            ? relativeVisibleCards
            : totalElements + 1,
        onOffsetChange: react_1.default.useCallback((offset) => {
            if (offset < maxTotalElements && !blockNavigation) {
                setActiveIndex(offset);
            }
        }, [blockNavigation, maxTotalElements])
    });
    /**
     * Use previous state from any number;
     * @param value : number
     */
    const usePrevious = (value) => {
        const ref = (0, react_1.useRef)(0);
        (0, react_1.useEffect)(() => {
            ref.current = value;
        });
        return ref.current;
    };
    // Prev state of visibleTabCount
    const prevVisibleTabCount = usePrevious(visibleTabCount);
    // Reset index when filters were applied
    (0, react_1.useEffect)(() => {
        setActiveIndex(0);
    }, [children]);
    // Set index on responsive interaction
    (0, react_1.useEffect)(() => {
        if (pageOffset) {
            // Get  first visible elemet index of array
            const elementIndex = activeIndex * (prevVisibleTabCount > 1 ? prevVisibleTabCount - 1 : 1);
            if (isMobileView) {
                setActiveIndex(elementIndex);
            }
            else {
                const currentPage = Math.floor(elementIndex / (visibleTabCount - 1));
                const totalPages = maxTotalElements - 1;
                setActiveIndex(currentPage > totalPages ? totalPages : currentPage);
            }
        }
    }, [visibleTabCount]);
    const updateNavigationIndex = (0, react_1.useCallback)((newIndex) => {
        onActionTrackingTrigger &&
            onActionTrackingTrigger('click', newIndex < activeIndex ? 'previous' : 'next', newIndex);
        setActiveIndex(newIndex);
    }, []);
    return (react_1.default.createElement(styled_1.StyleCarouselContainer, { className: "carousel-container" },
        react_1.default.createElement(styled_1.StylePaginationBarWrapper, { className: "pagination-bar-wrapper" }, !blockNavigation && (react_1.default.createElement(navigation_bar_1.NavigationBar, { index: activeIndex, 
            // On mobile uses simple index base 0, on desktop index is limiting by defined elements on view
            totalElements: !isMobileView
                ? pageOffset
                    ? maxTotalElements - 1
                    : totalElements - (visibleTabCount - 1)
                : totalElements - 1, setIndex: updateNavigationIndex, minElements: 0, pageNumber: getPageNumberString() }))),
        react_1.default.createElement(styled_1.StyledCarouselWrapper, { singleelement: isSingleElement || (isMobileView && hidePeekaboo), className: "carousel-wrapper" },
            react_1.default.createElement(slider_card_carousel_1.SliderCarousel, { slider: slider, visibleTabCount: isMobileView && (isSingleElement || hidePeekaboo)
                    ? 1
                    : visibleTabCount, sliderElementRef: sliderElementRef, slideGroup: pageOffset ? visibleTabCount - 1 : 1, 
                // Divide carousel in equals parts
                totalElements: isNotMinTotalElements ? visibleTabCount + 1 : totalElements, 
                // single elements doesn't need extra functionality and width
                singleelement: isSingleElement }, children.map((child, index) => (react_1.default.createElement(styled_1.StyledContainer, { key: child.key, singleelement: isSingleElement, className: "carousel-slide-container" }, react_1.default.cloneElement(child, {
                opacity: isElementOpacity(index)
            }))))))));
};
exports.CardCarousel = CardCarousel;
__exportStar(require("./navigation-bar"), exports);
